<template>
    <div class="l-edit-dialog-box">
        <el-form :model="form_data" label-width="120px" ref="form" :rules="rules" label-position="left" v-loading="loading">
            <el-row :gutter="50" style="margin-left:0;margin-right:0">

                <el-col :span="24">
                    <el-form-item label="员工ID" prop="staffId">
                        <el-input v-model="form_data.staffId" autocomplete="off" placeholder="请输入员工ID"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="24">
                    <el-form-item label="备注" prop="remark">
                        <el-input type="textarea" v-model="form_data.remark" autocomplete="off" :rows="4" maxlength="250"
                            placeholder="请输入备注" show-word-limit></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div class="l-dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
        </div>
    </div>
</template>
  
<script>
export default {
    name: 'l-app-user-force',
    props: {
        id: {
            type: [String, Number],
            default: null
        },
        visible: {
            type: Boolean,
        },
    },

    components: {
    },
    computed: {
        hasId() {
            return this.$props.id !== null;
        },
    },
    // watch: {

    // },
    data() {
        return {
            loading: false,//页面是否加载中
            //表单数据
            form_data: {
                staffId: "",
                remark: ""
                // add_time: "",
                // photo: []
            },
            //表单验证规则
            rules: {
                id: [
                    { required: true, message: '员工ID不能为空', trigger: 'change' }
                ],
            },
            //提交按钮是否显示加载中
            submitting: false,
        }
    },
    methods: {
    
        //点击取消通知父组件关闭对话框
        cancel() {
            this.$emit('update:visible', false);
        },

        //提交数据
        handleSubmit() {
            // console.log(this.form_data);
            if (this.loading) return;
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.submitting = true;
                    this.$_invoke('appUser_force', {
                        id: this.$props.id,
                        staffId: this.form_data.staffId,
                        remark: this.form_data.remark,
                    }).then(() => {
                        this.$_msg.success('改绑成功');
                        this.$emit('on-success');
                    }).finally(() => {
                        this.submitting = false;
                    })
                }
            }
            )

        },
    },
}
</script>